import { useState, useEffect, useRef } from 'react';
import { useAutoHedgeContext } from '../contexts/AutoHedgeContext';

export const usePositionSync = () => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { connectedAccounts, simulateExchangeAPI } = useAutoHedgeContext();
  
  // Prevent infinite loops with stable reference
  const stableAccountsRef = useRef([]);
  const positionsLoadedRef = useRef(false);

  const fetchPositions = async (exchangeId) => {
    try {
      setLoading(true);
      const positions = await simulateExchangeAPI(exchangeId, 'fetchPositions');
      console.log(`✅ STABLE: Fetched ${positions.length} positions from ${exchangeId}`);
      return positions;
    } catch (error) {
      console.warn(`Failed to fetch positions from ${exchangeId}:`, error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  // Only run when connected accounts actually change
  useEffect(() => {
    const accountIds = connectedAccounts.map(acc => acc.id).sort().join(',');
    const stableIds = stableAccountsRef.current.map(acc => acc.id).sort().join(',');
    
    // Only fetch if accounts actually changed
    if (accountIds !== stableIds) {
      console.log(`🔄 ACCOUNTS CHANGED: Loading positions for ${connectedAccounts.length} accounts`);
      stableAccountsRef.current = [...connectedAccounts];
      
      const loadAllPositions = async () => {
        if (connectedAccounts.length > 0) {
          const allPositions = [];
          
          for (const account of connectedAccounts) {
            const accountPositions = await fetchPositions(account.exchange);
            allPositions.push(...accountPositions);
          }
          
          setPositions(allPositions);
          positionsLoadedRef.current = true;
          console.log(`🎯 FINAL: ${allPositions.length} total positions loaded`);
        } else {
          setPositions([]);
          positionsLoadedRef.current = false;
        }
      };

      loadAllPositions();
    }
  }, [connectedAccounts]); // Only when connectedAccounts changes

  return { positions, loading, fetchPositions };
};
